import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-job-count',
  templateUrl: './job-count.component.html',
  styleUrls: ['./job-count.component.scss'],
})
export class JobCountComponent implements OnInit {
  @Input() jobCount: string;
  constructor() {}

  ngOnInit(): void {}
}
